import { axios } from '../plugins/http-axios';
import { Module } from 'vuex';
import { IStatus } from '@/store/app';

export interface IOptions {
  page: number;
  pageCount: number;
  itemsPerPage: number;
  totalCount: number;
  sortBy: string[];
  sortDesc: boolean[];
  search: string;
}
function _getXOptions(headers: any = {}): IOptions {
  return {
    page: +headers['x-pagination-current-page'] || 0,
    pageCount: +headers['x-pagination-page-count'] || 0,
    itemsPerPage: +headers['x-pagination-per-page'] || 0,
    totalCount: +headers['x-pagination-total-count'] || 0,
    sortBy: [],
    sortDesc: [],
    search: '',
  };
}

export interface IApp {
  id: string;
  orgnameshort: string;
  inn: string;
  createdate: string;
  number: string;
  status: IStatus;
  creator?: string | any;
  activeClient?: string | any;
}

interface IAppsState {
  apps: IApp[];
  options: IOptions;
  hasData: boolean;
  isLoading: boolean;
}

export default <Module<IAppsState, any>>{
  state: {
    apps: [],
    options: {
      page: 1,
      pageCount: 1,
      itemsPerPage: 10,
      totalCount: 0,
      sortBy: [],
      sortDesc: [],
      search: '',
    },
    hasData: false,
    isLoading: false,
  },
  mutations: {
    setOptions(state, options = {}) {
      for (let key in state.options) {
        //@ts-ignore
        state.options[key] = options[key];
      }
      localStorage.setItem('requestJournal', JSON.stringify(options));
    },
    setStatusById(state, { id = '', status = {} } = {}) {
      const app = state.apps.find((app) => app.id == id);
      if (app) app.status = status;
    },
    setApps(state, data = []) {
      state.apps = data;
    },
    addApp(state, app = <IApp>{}) {
      state.apps.unshift(app);
    },

    setHasData(state, flag) {
      state.hasData = flag;
    },
    setLoading(state, flag) {
      state.isLoading = flag;
    },
    /*
        //Расписать структуру входящего data, сделать так же в app.js->setApp
        pushApps(state, data = {}) {
            state.apps.unshift(data)
        },
*/
  },
  actions: {
    async getApplications({ commit, dispatch, rootGetters, state }, options: IOptions) {
      // if (getters.isApps)
      //     return Promise.resolve(getters.apps);

      const { sortBy, sortDesc, page, itemsPerPage: perPage, search = '' }: IOptions = options;
      const params = {
        params: {
          page: page || undefined,
          perPage: perPage || undefined,
          sort: sortBy[0],
          direct: sortDesc[0] ? 'desc' : sortDesc[0] === false ? 'asc' : undefined,
          search: search || undefined,
        },
      };
      commit('setLoading', true);

      try {
        try {
          const resp = await axios.get<IApp[]>(rootGetters.uri.apps, params);
          commit('setApps', resp.data);
          const options_2: IOptions = _getXOptions(resp.headers);
          options_2.sortBy = sortBy;
          options_2.sortDesc = sortDesc;
          options_2.search = search;

          if (!state.hasData) {
            commit('setHasData', Boolean(options_2.totalCount));
          }

          commit('setOptions', options_2);
          return await Promise.resolve();
        } catch (e) {
          // @ts-ignore
          e.uri = rootGetters.uri.apps;
          dispatch('setError', e);
          return await Promise.reject(e);
        }
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    isApps: (state: any): number => state.apps.length,
    apps: (state): IApp[] => state.apps,
    options: (state): IOptions => state.options,
    getHasData: (state): boolean => state.hasData,
    isLoadingApps: (state): boolean => state.isLoading,
  },
};
